import type { PublicSiteSettings } from "@/admin/types";
import { buildColorScale } from "./colorScale";

const setMetaContent = (name: string, content: string) => {
  if (!content) return;
  let meta = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute("name", name);
    document.head.appendChild(meta);
  }
  meta.setAttribute("content", content);
};

const setOgContent = (property: string, content: string) => {
  if (!content) return;
  let meta = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement | null;
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute("property", property);
    document.head.appendChild(meta);
  }
  meta.setAttribute("content", content);
};

const setFavicon = (url: string) => {
  if (!url) return;
  let link = document.querySelector("link[rel='icon']") as HTMLLinkElement | null;
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "icon");
    document.head.appendChild(link);
  }
  link.setAttribute("href", url);
};

export const applySiteTheme = (settings: PublicSiteSettings) => {
  const root = document.documentElement;
  const primary = buildColorScale(settings.primaryColor || "#E8927C");
  const secondary = buildColorScale(settings.secondaryColor || "#2A9D8F");
  const accent = buildColorScale(settings.accentColor || "#E9C46A");

  Object.entries(primary).forEach(([shade, value]) => {
    root.style.setProperty(`--color-primary-${shade}`, value);
  });
  Object.entries(secondary).forEach(([shade, value]) => {
    root.style.setProperty(`--color-secondary-${shade}`, value);
  });
  Object.entries(accent).forEach(([shade, value]) => {
    root.style.setProperty(`--color-accent-${shade}`, value);
  });

  if (settings.fontFamily) {
    root.style.setProperty("--font-sans", `"${settings.fontFamily}"`);
  }

  const title = settings.seoTitle || settings.siteName;
  if (title) {
    document.title = title;
  }

  setMetaContent("description", settings.seoDescription);
  setMetaContent("keywords", settings.seoKeywords);
  setOgContent("og:title", title);
  setOgContent("og:description", settings.seoDescription);
  setOgContent("og:image", settings.seoOgImageUrl);
  setFavicon(settings.faviconUrl);
};
